import { useEffect, useState } from "react";

enum Screen {
  HD_DESKTOP = 740,
  LAPTOP = 660,
  TABLET = 494
};

export type ConversationDetailSizes = 
  | Screen.HD_DESKTOP
  | Screen.LAPTOP
  | Screen.TABLET;

// Our post detail modal is a square
type Dimension = [ConversationDetailSizes, ConversationDetailSizes]; // width and height

function useStreamConversationModal(): Dimension {
  const [windowHeight, setWindowHeight] = useState<number>(window.innerHeight);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowHeight(window.innerHeight)
    };

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  if (windowHeight > Screen.HD_DESKTOP) {
    return [Screen.HD_DESKTOP, Screen.HD_DESKTOP];
  }
  
  if (windowHeight < Screen.LAPTOP) {
    return [Screen.TABLET, Screen.TABLET];
  }

  return [Screen.LAPTOP, Screen.LAPTOP];
}

export default useStreamConversationModal;